import PropTypes from "prop-types";
import React from "react";
import ProductgridList from "./ProductgridList";
import { Row, Spin } from 'antd';

const ShopProducts = ({ products, layout, sidebarFilter, loading,setScrollToTop }) => {
  return (
    <div className="shop-bottom-area mt-15" style={{ width: "100%" }}>
      <Spin spinning={loading}>
      <Row gutter={{
        xs: 8,
        sm: 16,
        md: 22,
        lg: 28,
      }}
      style={{marginLeft:"0px"}}
      >
        <ProductgridList products={products} spaceBottomClass="mb-25" layout={layout} sidebarFilter={sidebarFilter} setScrollToTop = {setScrollToTop} />
      </Row>
      </Spin>
    </div>
  );
};

ShopProducts.propTypes = {
  layout: PropTypes.string,
  products: PropTypes.array,
};

export default ShopProducts;
